var swiper = new Swiper(".mySwiper", {
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    slidesPerView:  (window.innerWidth>768 ? 2.4: 1.54),
        spaceBetween: 12,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  })
$('.faqblock-single-item-wrapper .faq-icon').on("click", function(){
var $c = $(this).closest('h3').next('.faqblock-item-content');
if($c.css('display')=='none'){
$c.css('display','block');
$(' .faq-line-1',this).css('height','0px')
}else{
$c.css('display','none');
$(' .faq-line-1',this).css('height','60%')
}
});